module.exports = __webpack_public_path__ + "static/media/agentAddress.aea052b9.svg";